import React from "react";
import SelectFilter from "../../../UniversalComponents/SelectFilter.component";
import "../../../../../styles/Pages/Financial/Accountant/Revenue/RevenueGraph.style.css";
import UniversalLineChartComponent from "../../../../Universal/UniversalLineChartComponent";

const RevenueGraph = ({ graphData }) => {

  return (
    <div className="revenueGraphComponent">
      <div className="graphHeader">
        <h3>Main stream revenue</h3>
        <SelectFilter />
      </div>
      <div className="graphContent">
        <div className="LineChart">
          <UniversalLineChartComponent
            data={graphData}
            lines={[{ dataKey: "revenue", name: "revenue", stroke: "#0040FF" }]}
            xAxisKey="date"
            referenceLinesValue={1000}
          />
        </div>
      </div>
    </div>
  );
};

export default RevenueGraph;
